import { useMemo } from 'react';

import {
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { useParams } from 'react-router';

import { useGetNotices } from '../../../query/notice';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import DataTable from '../data-table';
import { NOTICE_COLUMNS } from './notice-columns';

const NoticeTable = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const { data: notices } = useGetNotices({ courseId: courseId! });

  const tableData = useMemo(() => {
    if (!notices) return [];
    if (!notices.data) return [];
    return notices.data;
  }, [notices]);

  const table = useReactTable({
    data: tableData,
    columns: NOTICE_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  return (
    <Card className="bg-white">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>공지사항</CardTitle>
      </CardHeader>
      <CardContent>
        <DataTable table={table} />
      </CardContent>
    </Card>
  );
};

export default NoticeTable;
